/**
 * How the All buildings page lays a portfolio out:
 *
 * - `expanded` — a handful of buildings with few projects: cards, every
 *   project in view.
 * - `collapsed` — more buildings, or many projects: cards whose project lists
 *   start closed (each card's disclosure is remembered).
 * - `table` — a large portfolio: the dense sortable table.
 *
 * Decided on the unfiltered counts, so the layout never changes under the
 * user while they type in the search box.
 */
export type PortfolioLayout = "expanded" | "collapsed" | "table";

export const EXPANDED_MAX_BUILDINGS = 5;
export const EXPANDED_MAX_PROJECTS = 15;
export const CARDS_MAX_BUILDINGS = 25;

export function portfolioLayoutFor(buildingCount: number, projectCount: number): PortfolioLayout {
  if (buildingCount > CARDS_MAX_BUILDINGS) return "table";
  if (buildingCount <= EXPANDED_MAX_BUILDINGS && projectCount <= EXPANDED_MAX_PROJECTS) {
    return "expanded";
  }
  return "collapsed";
}
